import { Box, Button, FormControlLabel, Radio, RadioGroup, TextField, Typography } from "@mui/material";

import Grid from "@mui/material/Grid";

import React, { useEffect, useState } from "react";
// import {} from "../../utils/utils";
// import Youtube from '../assets/img/icon/youtube.png'
import { useSelector } from "react-redux";
// import { GetBussiness, UpdateBusiness } from "./myBusinessApi";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";

// import AddModal from "./AddModal";
import {
  franchiseRequirenmentAdd,
  franchiseRequirenmentUpdate,
  getFranchiseRequirenment,
} from "../MyFranchise/franchiseAPI";
import ConfirmDelete from "../Jobs/confirmDelete";
import { formDataFN } from "../../utils/commonUtils";
import { ADDCOMPANYPRODUCTS } from "../../utils/api";
// import { getCompanypRODUCTS } from "../WhiteLabels/whitelabelApi";
import {
  getCompanypRODUCTS,
  productAdd,
  productUpdate,
} from "../WhiteLabels/whitelabelApi";
// import { getInstitute, institueAdd, institueUpdate } from "./instituteApi";

export default function AddResaleFurnature({ setOpen, ModalData, open }) {
  const struct = {
    // id: 4,
    productName: "",
    productDescription: "",
    productId: "",
  };
  const [institute, setInstitute] = useState({ ...struct });
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const [selectedImages, setSelectedImages] = useState([]);

  let val = userDetail?.profileId?.split("?")[1];
  let billerId = Number(val?.split("=")[1]?.replace(/\D/g, ""));

  const getData = async () => {
    const payload = { billerId: billerId || userDetail?.userMasterId };

    getCompanypRODUCTS(payload, (res) => {
      // const obj = res?.data?.data?.list?.[0];
      // if (!obj) {
      //   // NO DATA → RESET FORM FOR ADD
      //   setInstitute({ ...struct, billerId });
      //   return;
      // }
      // setInstitute(obj);
      // console.log(obj);
    });

    // console.log("ll", institute?.instituteName);
  };

  useEffect(() => {
    if (ModalData && ModalData !== "all") {
      setInstitute({
        ...ModalData,
        logoPreview: ModalData?.productImage || "", // for existing image preview
      });
    } else {
      setInstitute({ ...struct });
    }
  }, [ModalData]);
  console.log(ModalData, "ModalData");

  const submit = async () => {
    let obj = {
      Id: institute?.id,
      ProductName: institute?.productName,
      ProductDescription: institute?.productDescription,
      ProductId: institute?.productId,
      IsActive: true,
    };

    selectedImages.forEach((ele, index) => {
      obj[`File${index + 1}`] = ele.file ? ele.file : ele.url;
    });

    if (institute.ProductImage instanceof File) {
      obj.ProductImage = institute.ProductImage;
    }

    let payload = formDataFN(obj);

    // const payload = {
    //   ...institute,
    // };
    if (!institute?.id) {
      await productAdd(payload, () => {
        getData();
        setOpen(false);
      });
    } else {
      await productUpdate(payload, () => {
        getData();
        setOpen(false);
      });
    }
  };
  useEffect(() => {
    getData();
  }, []);
  const labelStyle1 = {
    fontWeight: 600,
    color: "#000",
    fontSize: { xs: "12px", sm: "13px", md: "15px" },
    whiteSpace: "nowrap",
  };
  // return <h1>fet</h1>
  return (
    <Grid
      container
      px={{ sm: 4, xs: 2 }}
      pb={4}
      sx={{
        paddingTop: "15px",
        backgroundColor: "#E3E3FF",
        minHeight: "100vh",
      }}
    >
      {/* <DynamicBreadcrumbs /> */}

      <Grid item xs={12}>
        <Grid alignItems="center" container>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              "&:hover": {
                backgroundColor: "transparent", // removes hover background
              },
            }}
          >
            <KeyboardBackspaceIcon sx={{ fontSize: 30, color: "#01008B" }} />
          </IconButton>
          <Grid
            item
            xs={10}
            sm={10}
            sx={{
              background:
                "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
              padding: "10px 15px",
              mt: { sm: "10px", xs: "1px" },
              borderRadius: "5px",
              color: "#01008B", // optional text color
              textAlign: "left",
              marginBottom: "20px",
              fontFamily: "'Montserrat', sans-serif",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },

              fontWeight: 500,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "13px", sm: "14px", md: "20px" },
              }}
            >
              Add Resale Furniture & Equipments
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{
            margin: 0,
            padding: { xs: "10px", sm: "20px" },
            borderRadius: "10px",
            backgroundColor: "#fff",
            maxHeight: "70vh",
            overflow: "auto",
            // pr: { xs: 1, sm: 4 },
          }}
        >
          <Grid container spacing={2} mb={1}>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                id="title"
                size="small"
                label="Item Id"
                value={institute?.productId}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    productId: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>

            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                id="territory"
                label="Company  Name"
                size="small"
                value={institute?.productName}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    productName: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                id="title"
                size="small"
                label="Item code"
                value={institute?.productId}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    productId: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} mb={1}>
            <Grid mb={1} item xs={12}>
              <TextField
                fullWidth
                multiline
                label="Item Description"
                minRows={2}
                size="small"
                value={institute?.productDescription}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    productDescription: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid mb={1} item xs={12}>
              <TextField
                fullWidth
                multiline
                label="Item Specification"
                minRows={2}
                size="small"
                value={institute?.productDescription}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    productDescription: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={1} mb={1}>
            <Grid item md={4} xs={12}>
              <TextField
                fullWidth
                id="title"
                size="small"
                label="Usage Duration"
                value={institute?.productId}
                onChange={(e) => {
                  setInstitute({
                    ...institute,
                    productId: e.target.value,
                  });
                }}
                InputLabelProps={{
                  sx: {
                    // color: "#545454",
                    // fontWeight: 400,
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // paddingX: "7px",
                  },
                }}
                InputProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    // fontWeight: 500,
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <input
                type="file"
                id="imageUpload"
                style={{ display: "none" }}
                accept="image/*"
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  if (file) {
                    setInstitute((prev) => ({
                      ...prev,
                      ProductImage: file,
                      logoPreview: URL.createObjectURL(file), // ✅ THIS drives preview
                    }));
                  }
                }}
              />

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {institute?.logoPreview ? (
                  // ✅ NEW IMAGE PREVIEW
                  <Box
                    component="img"
                    src={institute.logoPreview}
                    alt="Preview"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      width: { xs: "100px", sm: "150px" },
                      height: { xs: "100px", sm: "150px" },
                      cursor: "pointer",
                      // borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : institute?.logo ? (
                  // ✅ EXISTING IMAGE FROM API
                  <Box
                    component="img"
                    src={institute.logo}
                    alt="Existing"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      width: { xs: "100px", sm: "120px", md: "150px" },
                      height: { xs: "100px", sm: "120px", md: "150px" },
                      cursor: "pointer",
                      // borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  // ✅ NO IMAGE
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() =>
                      document.getElementById("imageUpload").click()
                    }
                    sx={{
                      position: "relative",
                      justifyContent: "center",
                    }}
                  >
                    {/* Icon on the left */}
                    <AddAPhotoOutlinedIcon
                      sx={{
                        position: "absolute",
                        left: 16,
                      }}
                    />
                    Attach image for display
                  </Button>
                )}

                <input
                  type="file"
                  id="imageUpload"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      setInstitute((prev) => ({
                        ...prev,
                        ProductImage: file,
                        logoPreview: URL.createObjectURL(file), // ✅ THIS drives preview
                      }));
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                gap={0}
                px={3}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    color: "#01008B",
                  }}
                >
                  Is the price negotiable? :
                </Typography>

                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  sx={{ flexDirection: "row", gap: 1 }}
                  // onChange={(e) =>
                  //   setFormData((prev) => ({
                  //     ...prev,
                  //     internshipProvided: e.target.value === "true",
                  //   }))
                  // }
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                          color: "#01008B",
                          fontSize: { xs: "12px", sm: "13px", md: "14px" },
                        }}
                      >
                        Yes
                      </Typography>
                    }
                    // checked={
                    //   formData.internshipProvided == "true" ||
                    //   formData.internshipProvided == true
                    // }
                    className="mulish"
                    // onClick={gender}
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    // checked={
                    //   formData.internshipProvided == "false" ||
                    //   formData.internshipProvided == false
                    // }
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          whiteSpace: "nowrap",
                          fontWeight: 500,
                          color: "#01008B",
                          fontSize: { xs: "12px", sm: "13px", md: "14px" },
                        }}
                      >
                        No
                      </Typography>
                    }
                    className="mulish"
                    // onClick={gender}
                  />
                </RadioGroup>
              </Box>
            </Grid>
          </Grid>

          {/* .Button */}
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "60%",
                mx: "auto",
              }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                onClick={submit}
                sx={{
                  mt: 3,
                  mb: 2,
                  py: 1,
                  fontSize: { xs: "12px", sm: "13px", md: "16px" },
                  fontWeight: 500,
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
